export const locale = {
    lang: "th",
    data: {
      NAV: {
        NOTIFICATION: "การแจ้งเตือน",
        NEW:"ใหม่"
      }
    }
  };